// import { Container, Row, Col, Card } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import "./lessonTest.css";
import CodeExecutor from "../../../components/CodeExecutor/CodeExecutor.js";

import {
  Card,
  Container,
  Row,
  Col,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  Button,
  CardFooter,
} from "reactstrap";
// import DemoNavbar from "../../../components/DemoNavbar/DemoNavbar";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SplitPane from "react-split-pane";

class Lesson extends React.Component {
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }



  render() {
    return (
      <>
        <DemoNavbar />

        <main ref="main">
          <section className="section section-shaped section-lg">
            <div className="  shape shape-style-1 bg-gradient-default">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            {/* <SplitPane
                split="vertical"
                minSize={50}

       
              >         */}
            <Row className="justify-content-center ">


              {/* <Col
                xs={4}
                md={4}
                lg={4}
                className="blackBorder"
                style={{ padding: 0 }}
              >
                <Card
                  className="my-2 lessonCard "
                  style={{
                    width: "18rem",
                  }}
                >
                  <CardHeader>Header</CardHeader>
                  <CardBody>
                    <CardTitle tag="h5">Special Title Treatment</CardTitle>
                    <CardText>
                      With supporting text below as a natural lead-in to
                      additional content.
                    </CardText>
                    <Button>Go somewhere</Button>
                  </CardBody>
                  <CardFooter>Footer</CardFooter>
                </Card>

              </Col> */}
              <Col  style={{ padding: 0 }}>
                <CodeExecutor  languageCode="javascript" >
                  <Card
                    className="my-2 lessonCard "
                    style={{
                      width: "18rem",
                    }}
                  >
                    <CardHeader>Header</CardHeader>
                    <CardBody>
                      <CardTitle tag="h5">Special Title Treatment</CardTitle>
                      <CardText>
                        With supporting text below as a natural lead-in to
                        additional content.
                      </CardText>
                      <Button>Go somewhere</Button>
                    </CardBody>
                    <CardFooter>Footer</CardFooter>
                  </Card>
                </CodeExecutor>
              </Col>
              {/* </div> */}


            </Row>
            {/* </SplitPane> */}




          </section>

          {/* <div className="App">
            <SplitPane
              split="vertical"
              minSize={50}
              defaultSize={200}
              style={{ height: "100vh" }}
            >
              <div className="Pane1">
                <h2>Left Pane</h2>
                <p>Content for the left pane goes here.</p>
              </div>
              <div className="Pane2">
                <h2>Right Pane</h2>
                <p>Content for the right pane goes here.</p>
              </div>
            </SplitPane>
          </div> */}
        </main>
      </>
    );
  }
}

export default Lesson;
